/**
 * @flow
 * @relayHash 1beea59a8fd8a11c887ec8809c900fdd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HomeContent_currentTenant$ref = any;
export type ApplicabilityType = "LOCAL" | "LOCALIZED" | "SYSTEM" | "%future added value";
export type RevisionStatus = "NEW" | "REVISED" | "UNCHANGED" | "%future added value";
export type HomeContentQueryVariables = {||};
export type HomeContentQueryResponse = {|
  +pendingDocuments: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +pk: ?number,
          +name: string,
          +bloc: {|
            +name: string
          |},
          +applicabilityType: ?ApplicabilityType,
          +category: {|
            +name: string
          |},
          +effectiveDate: ?string,
          +restricted: boolean,
          +legacyEffectiveDate: ?string,
        |}
      |}>,
    |},
    +viewOnlyPks: ?$ReadOnlyArray<?number>,
  |},
  +documentsToReviewHome: ?{|
    +documents: ?$ReadOnlyArray<?{|
      +pk: ?number,
      +name: string,
      +bloc: {|
        +name: string
      |},
      +applicabilityType: ?ApplicabilityType,
      +category: {|
        +name: string
      |},
      +expirationDate: ?string,
      +restricted: boolean,
    |}>,
    +totalCount: ?number,
    +buckets: ?any,
  |},
  +myDocumentsToAcknowledge: ?{|
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +totalAcknowledged: ?number,
        +totalAssigned: ?number,
        +line: ?{|
          +pk: ?number,
          +document: ?{|
            +pk: ?number,
            +name: string,
            +hasAttachments: ?boolean,
            +effectiveDate: ?string,
            +legacyEffectiveDate: ?string,
            +restricted: boolean,
            +category: {|
              +name: string
            |},
            +bloc: {|
              +name: string
            |},
            +applicabilityType: ?ApplicabilityType,
          |},
        |},
      |}
    |}>,
  |},
  +recentlyRevisedDocuments: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +pk: ?number,
          +name: string,
          +bloc: {|
            +name: string
          |},
          +category: {|
            +name: string
          |},
          +applicabilityType: ?ApplicabilityType,
          +revisedFromParent: ?boolean,
          +effectiveDate: ?string,
          +legacyEffectiveDate: ?string,
          +restricted: boolean,
          +revisedFromParentStatus: ?RevisionStatus,
        |}
      |}>,
    |},
    +buckets: ?any,
  |},
  +blocSystemDocumentTemplatesAcceptance: ?{|
    +blocSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +systemDocumentTemplate: {|
            +pk: ?number,
            +name: string,
            +category: {|
              +name: string
            |},
          |},
          +publishDate: ?string,
          +document: ?{|
            +pk: ?number
          |},
        |}
      |}>,
    |},
    +buckets: ?any,
  |},
  +currentTenant: ?{|
    +$fragmentRefs: HomeContent_currentTenant$ref
  |},
|};
export type HomeContentQuery = {|
  variables: HomeContentQueryVariables,
  response: HomeContentQueryResponse,
|};
*/


/*
query HomeContentQuery {
  pendingDocuments(showAll: false) {
    documents(first: 5) {
      totalCount
      edges {
        node {
          id
          pk
          name
          bloc {
            name
            id
          }
          applicabilityType
          category {
            name
            id
          }
          effectiveDate
          restricted
          legacyEffectiveDate
        }
      }
    }
    viewOnlyPks
  }
  documentsToReviewHome {
    documents {
      pk
      name
      bloc {
        name
        id
      }
      applicabilityType
      category {
        name
        id
      }
      expirationDate
      restricted
      id
    }
    totalCount
    buckets
  }
  myDocumentsToAcknowledge(first: 5) {
    totalCount
    edges {
      node {
        totalAcknowledged
        totalAssigned
        line {
          pk
          document {
            pk
            name
            hasAttachments
            effectiveDate
            legacyEffectiveDate
            restricted
            category {
              name
              id
            }
            bloc {
              name
              id
            }
            applicabilityType
            id
          }
          id
        }
      }
    }
  }
  recentlyRevisedDocuments {
    documents(first: 5) {
      totalCount
      edges {
        node {
          pk
          name
          bloc {
            name
            id
          }
          category {
            name
            id
          }
          applicabilityType
          revisedFromParent
          effectiveDate
          legacyEffectiveDate
          restricted
          revisedFromParentStatus
          id
        }
      }
    }
    buckets
  }
  blocSystemDocumentTemplatesAcceptance {
    blocSystemDocumentTemplates(first: 5) {
      totalCount
      edges {
        node {
          systemDocumentTemplate {
            pk
            name
            category {
              name
              id
            }
            id
          }
          publishDate
          document {
            pk
            id
          }
          id
        }
      }
    }
    buckets
  }
  currentTenant {
    ...HomeContent_currentTenant
    id
  }
}

fragment HomeContent_currentTenant on TenantType {
  settings {
    customWelcomeContentShow
    customWelcomeContentPsa
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "showAll",
    "value": false,
    "type": "Boolean"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5,
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  v5
],
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": v6
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "applicabilityType",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v6
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewOnlyPks",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAcknowledged",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalAssigned",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasAttachments",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisedFromParent",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisedFromParentStatus",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishDate",
  "args": null,
  "storageKey": null
},
v22 = [
  v5,
  v3
],
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": v22
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v22
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeContentQuery",
  "id": "98b7aaef5d58e3ef02e01aaeff1e0bf3",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeContentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      v7,
                      v8,
                      v9,
                      v10,
                      v11,
                      v12
                    ]
                  }
                ]
              }
            ]
          },
          v13
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v4,
              v5,
              v7,
              v8,
              v9,
              v14,
              v11
            ]
          },
          v2,
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "myDocumentsToAcknowledge",
        "storageKey": "myDocumentsToAcknowledge(first:5)",
        "args": v1,
        "concreteType": "CountableConnectionAcknowledgmentConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CountableConnectionAcknowledgmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AcknowledgmentDocumentLineType",
                "plural": false,
                "selections": [
                  v16,
                  v17,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentLineType",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v18,
                          v10,
                          v12,
                          v11,
                          v9,
                          v7,
                          v8
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "recentlyRevisedDocuments",
        "storageKey": null,
        "args": null,
        "concreteType": "NewAndRecentlyRevisedType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v7,
                      v9,
                      v8,
                      v19,
                      v10,
                      v12,
                      v11,
                      v20
                    ]
                  }
                ]
              }
            ]
          },
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": null,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": "blocSystemDocumentTemplates(first:5)",
            "args": v1,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v9
                        ]
                      },
                      v21,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HomeContent_currentTenant",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeContentQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      v23,
                      v8,
                      v24,
                      v10,
                      v11,
                      v12
                    ]
                  }
                ]
              }
            ]
          },
          v13
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v4,
              v5,
              v23,
              v8,
              v24,
              v14,
              v11,
              v3
            ]
          },
          v2,
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "myDocumentsToAcknowledge",
        "storageKey": "myDocumentsToAcknowledge(first:5)",
        "args": v1,
        "concreteType": "CountableConnectionAcknowledgmentConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CountableConnectionAcknowledgmentEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "AcknowledgmentDocumentLineType",
                "plural": false,
                "selections": [
                  v16,
                  v17,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentLineType",
                    "plural": false,
                    "selections": [
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v18,
                          v10,
                          v12,
                          v11,
                          v24,
                          v23,
                          v8,
                          v3
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "recentlyRevisedDocuments",
        "storageKey": null,
        "args": null,
        "concreteType": "NewAndRecentlyRevisedType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v23,
                      v24,
                      v8,
                      v19,
                      v10,
                      v12,
                      v11,
                      v20,
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": null,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": "blocSystemDocumentTemplates(first:5)",
            "args": v1,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v24,
                          v3
                        ]
                      },
                      v21,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v3
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v15
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "currentTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "settings",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantSettingsType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customWelcomeContentShow",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customWelcomeContentPsa",
                "args": null,
                "storageKey": null
              },
              v3
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
node.text = "query HomeContentQuery {\n  pendingDocuments(showAll: false) {\n    documents(first: 5) {\n      totalCount\n      edges {\n        node {\n          id\n          pk\n          name\n          bloc {\n            name\n            id\n          }\n          applicabilityType\n          category {\n            name\n            id\n          }\n          effectiveDate\n          restricted\n          legacyEffectiveDate\n        }\n      }\n    }\n    viewOnlyPks\n  }\n  documentsToReviewHome {\n    documents {\n      pk\n      name\n      bloc {\n        name\n        id\n      }\n      applicabilityType\n      category {\n        name\n        id\n      }\n      expirationDate\n      restricted\n      id\n    }\n    totalCount\n    buckets\n  }\n  myDocumentsToAcknowledge(first: 5) {\n    totalCount\n    edges {\n      node {\n        totalAcknowledged\n        totalAssigned\n        line {\n          pk\n          document {\n            pk\n            name\n            hasAttachments\n            effectiveDate\n            legacyEffectiveDate\n            restricted\n            category {\n              name\n              id\n            }\n            bloc {\n              name\n              id\n            }\n            applicabilityType\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n  recentlyRevisedDocuments {\n    documents(first: 5) {\n      totalCount\n      edges {\n        node {\n          pk\n          name\n          bloc {\n            name\n            id\n          }\n          category {\n            name\n            id\n          }\n          applicabilityType\n          revisedFromParent\n          effectiveDate\n          legacyEffectiveDate\n          restricted\n          revisedFromParentStatus\n          id\n        }\n      }\n    }\n    buckets\n  }\n  blocSystemDocumentTemplatesAcceptance {\n    blocSystemDocumentTemplates(first: 5) {\n      totalCount\n      edges {\n        node {\n          systemDocumentTemplate {\n            pk\n            name\n            category {\n              name\n              id\n            }\n            id\n          }\n          publishDate\n          document {\n            pk\n            id\n          }\n          id\n        }\n      }\n    }\n    buckets\n  }\n  currentTenant {\n    ...HomeContent_currentTenant\n    id\n  }\n}\n\nfragment HomeContent_currentTenant on TenantType {\n  settings {\n    customWelcomeContentShow\n    customWelcomeContentPsa\n    id\n  }\n}\n";
(node/*: any*/).hash = '46db18945bf365eb6923866456491dd0';
module.exports = node;
